import Hero from "./Hero";
import Timeline from "./Timeline";
import University from "./University";
import Reasons from "./Reasons";
import Clip from "./Clip";
import ISO from "./ISO";
import Team from "./Team";
import Life from "./Life";
import wrapperClasses from "../../components/commons/Wrapper.module.scss";
import classes from "./index.module.scss";
import {Helmet} from "react-helmet";
import {ABOUT_TITLE, ABOUT_DESCRIPTION} from "../../constants/seo";
import React from "react";

export default function AboutUs() {
  return (
      <>
        <Helmet>
            <title>{ABOUT_TITLE}</title>
            <meta name="title" content={ABOUT_TITLE} />
            <meta name="description" content={ABOUT_DESCRIPTION} />
            <meta
                property="og:title"
                content={ABOUT_TITLE}
            />
            <meta
                property="og:description"
                content={ABOUT_DESCRIPTION}
            />
        </Helmet>

        <section className={`${wrapperClasses.section} ${classes.section}`}>
          <Hero />
          <Timeline />
          <University />
          <Reasons />
          <Clip />
          <Life />
          <Team />
          <ISO />
        </section>
      </>
  );
}
